import Typography from "@mui/material/Typography";
import { isEmpty } from "ramda";
import { isNotNilOrEmpty } from "ramda-adjunct";
import React, { FC } from "react";
import { useMuiController } from "@sinch/components";
import { RateBuilderTreeFormFields } from "@sinch/components/application/RatelistBuilder/ratelistBuilderSchema";
import { QuickEditText } from "@sinch/components/form/QuickEditText/QuickEditText";

interface RatelistRowNameProps {
  rowId: string;
}

export const RatelistRowName: FC<RatelistRowNameProps> = ({ rowId }) => {
  const { field } = useMuiController<RateBuilderTreeFormFields, `Rate.${string}.name`>({
    name: `Rate.${rowId}.name`,
    disableAsReadOnly: true,
  });

  return (
    (isNotNilOrEmpty(field.value) || isEmpty(field.value)) && (
      <QuickEditText onBlur={field.onBlur} onChange={field.onChange} value={field.value ?? ""}>
        <Typography sx={{ fontWeight: "400" }} variant="h3">
          {field.value}
        </Typography>
      </QuickEditText>
    )
  );
};
